<template>
  <div ref="rightPanel" :class="{show:show}" class="rightPanel-container">
    <div class="rightPanel-background" />
    <div class="rightPanel">
      <div
        id="dragBtn"
        class="handle-button"
        v-drag="false"
        v-if="!$store.state.isMB"
        :style="{'top':buttonTop+'px','background-color':'#409EFF'}"
        @click="showRightPanel"
      >
        <i :class="show?'el-icon-close':'el-icon-setting'" />
      </div>
      <div class="rightPanel-items">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { addClass, removeClass } from "@/utils";

export default {
  name: "RightPanel",
  props: {
    clickNotClose: {
      default: false,
      type: Boolean,
    },
    buttonTop: {
      default: 250,
      type: Number,
    },
  },
  data() {
    return {
      show: false,
      isDrag: false,
    };
  },
  directives: {
    drag: function (el, binding, vnode) {
      /** el可以获取当前dom节点，并且进行编译，也可以操作事件 **/
      /** binding指的是一个对象，一般不用 **/
      /** vnode 是 Vue 编译生成的虚拟节点 **/
      // el.style.border = "1px solid red"; //操作style所有样式
      //  //获取v-model的值
      //  //data-name绑定的值，需要el.dataset来获取
      //  //获取当前路由信息
      // 
      let oDiv = el; //el --> 触发的DOM元素
      let isDrag = false;
      oDiv.onmousedown = function (e) {
        if (oDiv.children[0].className == "el-icon-close") {
          return;
        }
        addClass(document.body, "disabled-select");
        document.getElementById("dragBtn").setAttribute("flag", false);
        // let l = e.clientX - oDiv.offsetLeft;
        let t = e.clientY - oDiv.offsetTop;
        document.onmousemove = function (e) {
          // oDiv.style.left = e.clientX - l + "px";
          if (e.clientY - t > 85) {
            oDiv.style.top = e.clientY - t + "px";
          }
          isDrag = true;
        };
        oDiv.onmouseup = function () {
          let o = oDiv.offsetTop + oDiv.offsetHeight;
          let h = document.body.offsetHeight;
          if (o > h) {
            let top = oDiv.offsetTop + (h - o);
            oDiv.style.top = top - 1 + "px";
          }
          if (!isDrag) {
            document.getElementById("dragBtn").setAttribute("flag", true);
          }
          isDrag = false;
          document.onmousemove = null;
          oDiv.onmouseup = null;
          removeClass(document.body, "disabled-select");
        };
        document.onmouseup = function () {
          if (document.onmousemove) {
            let o = oDiv.offsetTop + oDiv.offsetHeight;
            let h = document.body.offsetHeight;
            if (o > h) {
              let top = oDiv.offsetTop + (h - o);
              oDiv.style.top = top - 1 + "px";
            }
            document.onmousemove = null;
            isDrag = false;
          }
        };
      };
    },
  },
  computed: {},
  watch: {
    // show(value) {
    //   if (value && !this.clickNotClose) {
    //     this.addEventClick();
    //   }
    //   if (value) {
    //     addClass(document.body, "showRightPanel");
    //   } else {
    //     removeClass(document.body, "showRightPanel");
    //   }
    // },
  },
  mounted() {
    this.insertToBody();
  },
  beforeDestroy() {
    const elx = this.$refs.rightPanel;
    elx.remove();
  },
  methods: {
    showRightPanel() {
      let isClick = document.getElementById("dragBtn").getAttribute("flag");
      if (isClick !== "true") {
        return false;
      }
      // 
      if (this.show) {
        this.show = false;
        removeClass(document.body, "showRightPanel");
      } else {
        this.show = true;
        addClass(document.body, "showRightPanel");
      }
    },
    // addEventClick() {
    //   window.addEventListener("click", this.closeSidebar);
    // },
    // closeSidebar(evt) {
    //   const parent = evt.target.closest(".rightPanel");
    //   if (!parent) {
    //     this.show = false;
    //     window.removeEventListener("click", this.closeSidebar);
    //   }
    // },
    insertToBody() {
      const elx = this.$refs.rightPanel;
      const body = document.querySelector("body");
      body.insertBefore(elx, body.firstChild);
    },
  },
};
</script>

<style>
.showRightPanel {
  overflow: hidden;
  position: relative;
  width: 100%;
}
</style>

<style lang="scss" scoped>
.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
  background: rgba(0, 0, 0, 0.2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  transition: all 0.25s cubic-bezier(0.7, 0.3, 0.1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 2000;
}

.show {
  transition: all 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);

  .rightPanel-background {
    z-index: 1999;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #fff;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}
</style>
